const BASE_URL = "https://api.crew.clikkle.com";

export default BASE_URL;
